import React from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import { Navbar, Nav, Container, Card, Badge } from "react-bootstrap";
import "./App.css";

const cards = [
  {
    id: 1,
    tag: "Components",
    title: "Building Blocks of React",
    text: "React apps are built from isolated pieces of UI called components. Each component is a JavaScript function that returns markup — composable, reusable, and independently testable.",
    image: "https://images.unsplash.com/photo-1633356122544-f134324a6cee?w=600&q=80",
    accent: "#f59e0b",
    link: "https://react.dev/learn/your-first-component",
  },
  {
    id: 2,
    tag: "State & Props",
    title: "Data That Drives Your UI",
    text: "Props let you pass data into components. State lets components remember information between renders. Together they form the reactive data model that makes React powerful.",
    image: "https://images.unsplash.com/photo-1555099962-4199c345e5dd?w=600&q=80",
    accent: "#10b981",
    link: "https://react.dev/learn/state-a-components-memory",
  },
  {
    id: 3,
    tag: "Hooks",
    title: "Supercharge Functional Components",
    text: "Hooks like useState, useEffect, and useRef let you tap into React features from function components — no class syntax needed. Write less, do more.",
    image: "https://images.unsplash.com/photo-1526374965328-7f61d4dc18c5?w=600&q=80",
    accent: "#8b5cf6",
    link: "https://react.dev/reference/react",
  },
];

function App() {
  return (
    <>
      <div className="App">
        <div className="bg-orb orb-a" />
        <div className="bg-orb orb-b" />
        <div className="bg-orb orb-c" />

        <Navbar expand="lg" className="site-navbar" fixed="top">
          <Container>
            <Navbar.Brand href="#home" className="navbar-brand-custom">
              <span className="brand-dot" />
              React<span className="brand-accent">JS</span>
            </Navbar.Brand>
            <Navbar.Toggle aria-controls="main-nav" />
            <Navbar.Collapse id="main-nav">
              <Nav className="ms-auto nav-links">
                <Nav.Link href="#home" className="nav-item-custom active-link">Home</Nav.Link>
                <Nav.Link href="#concepts" className="nav-item-custom">Concepts</Nav.Link>
                <Nav.Link href="#docs" className="nav-item-custom">Docs</Nav.Link>
                <Nav.Link href="https://react.dev" target="_blank" rel="noreferrer" className="nav-item-custom nav-cta">
                  Get Started ↗
                </Nav.Link>
              </Nav>
            </Navbar.Collapse>
          </Container>
        </Navbar>

        <section className="hero-section" id="home">
          <Container>
            <div className="hero-inner">
              <p className="hero-eyebrow">React JS · Fundamentals</p>
              <h1 className="hero-heading">
                Build UIs<br />
                <span className="heading-accent">That Think.</span>
              </h1>
              <p className="hero-sub">
                A declarative, component-based library for crafting fast, interactive user interfaces. Start small. Scale infinitely.
              </p>
              <div className="hero-tags">
                <span className="tag">v19.0</span>
                <span className="tag">Open Source</span>
                <span className="tag">Meta OSS</span>
              </div>
            </div>
          </Container>
        </section>

        <section className="cards-section" id="concepts">
          <Container>
            <p className="section-label">Core Concepts</p>
            <div className="cards-grid">
              {cards.map((card, i) => (
                <Card
                  key={card.id}
                  className="concept-card"
                  style={{ "--accent": card.accent, animationDelay: `${i * 0.12}s` }}
                >
                  <div className="card-img-wrap">
                    <Card.Img variant="top" src={card.image} alt={card.title} className="card-photo" />
                    <div className="card-img-overlay-gradient" style={{ background: `linear-gradient(180deg, transparent 40%, ${card.accent}22 100%)` }} />
                  </div>
                  <Card.Body className="card-body-custom">
                    <Badge className="concept-badge" style={{ background: card.accent }}>
                      {card.tag}
                    </Badge>
                    <Card.Title className="card-title-custom">{card.title}</Card.Title>
                    <Card.Text className="card-text-custom">{card.text}</Card.Text>
                  </Card.Body>
                  <Card.Footer className="card-footer-custom">
                    <a href={card.link} target="_blank" rel="noreferrer" className="card-link" style={{ color: card.accent }}>
                      Read the docs <span className="link-arrow">→</span>
                    </a>
                  </Card.Footer>
                </Card>
              ))}
            </div>
          </Container>
        </section>

        <footer className="site-footer">
          <Container>
            <span>Built with React &amp; React Bootstrap · {new Date().getFullYear()}</span>
          </Container>
        </footer>
      </div>
    </>
  );
}

export default App;